import React from 'react';
import AutoSizer, {AutoSizerProps} from 'react-virtualized-auto-sizer';

export const FAKE_AUTO_SIZER_HEIGHT = 400;
export const FAKE_AUTO_SIZER_WIDTH = 3000;

const FakeAutoSizer: React.FunctionComponent = ({children, disableHeight}: AutoSizerProps): JSX.Element => (
  // styles from the real AutoSizer's source; we never use disableWidth
  <div style={{overflow: 'visible', height: disableHeight ? 0 : undefined}}>
    {children({height: FAKE_AUTO_SIZER_HEIGHT, width: FAKE_AUTO_SIZER_WIDTH})}
  </div>
);

const AutoSizerWrapper: React.ElementType<AutoSizerProps> = (props: AutoSizerProps) =>
  global.__NODE_TESTING__ ? <FakeAutoSizer {...props} /> : <AutoSizer {...props} />;

export default AutoSizerWrapper;
